import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { leadKeys } from '@/lib/queryKeys';
import { leadEndpoints } from '@/lib/api/endpoints';
import { apiPut, operationsClient } from '@/lib/api';
import type { LeadSettings } from './useLeadSettings';

export function useUpdateLeadSettings() {
  const queryClient = useQueryClient();

  return useApiMutation<LeadSettings, Partial<LeadSettings>>({
    mutationFn: (dto) =>
      apiPut<LeadSettings, Partial<LeadSettings>>(operationsClient, leadEndpoints.settings(), dto),
    onSuccess: (data) => {
      queryClient.setQueryData(leadKeys.settings(), data);
      toast.success('Lead settings saved');
    },
  });
}
